module.exports = __webpack_public_path__ + "static/media/default-red-cross.527efac0.svg";